import React from "react";

import {
    Container,
    Typography
} from "@mui/material";

import KnowledgeExplorer from "../components/knowledge/KnowledgeExplorer";

export default function KnowledgePage() {

    return (

        <Container
            maxWidth={false}
            sx={{ mt: 3 }}
        >

            <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
            >

                Knowledge Repository

            </Typography>

            <KnowledgeExplorer />

        </Container>

    );

}